import React,{useState} from "react";
import useStyles from './Style.js'
import { Link} from "react-router-dom";
import { Card,CardActions,CardContent,CardMedia,Button,Typography } from "@material-ui/core";
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt'
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAltOutlined';

import DeleteIcon from '@material-ui/icons/Delete'
import MoreHorizIcon  from '@material-ui/icons/MoreHoriz'
import moment from 'moment'
import { useDispatch } from "react-redux";
import { deletePost,likePost } from "../../../actions/posts.js";
import { Modal } from "../../Modal/Modal.js";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';




const Post=({post,setCurrentId})=>{
    const cls=useStyles();
    const dispatch=useDispatch();
    const user=JSON.parse(localStorage.getItem('profile'))
    const [view,setView]=useState(false);


    const Likes = () => {
        if (post.likes.length > 0) {
           return post.likes.find((like) => like === user?.result?._id)
              ? (
                 <div><ThumbUpAltIcon fontSize="small" />&nbsp;{post.likes.length > 2 ? `You and ${post.likes.length - 1} others` : `${post.likes.length} like${post.likes.length > 1 ? 's' : ''}`}</div>
              ) 
              :
               (
                 <div><ThumbUpAltOutlined fontSize="small" />&nbsp;{post.likes.length} {post.likes.length === 1 ? 'Like' : 'Likes'}</div>
              );
        }
  
        return <div><ThumbUpAltOutlined fontSize="small" />&nbsp;Like</div>;
     };
    
    return (
        <Card className={cls.card}>
            <CardMedia className={cls.media} image={post.selectedFile} title={post.title}>  </CardMedia>

                <div className={cls.overlay}>
                    <Typography variant="h6">{post.name}</Typography>
                    <Typography variant="body2">{moment(post.createdAt).fromNow()}</Typography>
                </div>
                {(user?.result._id===post?.creator)&&(
                <div className={cls.overlay2}>

                <Button style={{color:'white'}} size='small' onClick={()=>{
                    setCurrentId(post._id) 
                 setView(true) }}>
                        <MoreHorizIcon fontSize="medium"/></Button>
                        {view?( <Modal setView={setView}/>):(<div></div>)}
                      
                       
                </div>
                
                )}
                <div className={cls.details}>
                    <Typography variant="body2" color="textSecondary">{post.tags.map((tag)=>`#${tag}`)}</Typography>
                </div>
                <Typography className={cls.title} variant="h5" gutterBottom>{post.title}</Typography>
                <CardContent>
                    <Typography  variant="body2" color="textSecondary" component="p">{post.message}</Typography>
                </CardContent>
                <CardActions className={cls.cardActions}>
                    <Button size="small" color="primary" disabled={!user?.result} onClick={()=>{dispatch(likePost(post._id))}}>
                       <Likes />
                    </Button>
                    {(user?.result._id===post?.creator)&&(
                        <Button size="small" color="secondary"  onClick={()=>{dispatch(deletePost(post._id))}}>
                        <DeleteIcon fontSize="small"/>
                            Delete &nbsp;
                    </Button>
                    )}
                   
                </CardActions>
        </Card>
    )
}

export default Post;